import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.create-statement-item.presenters.CreateStatementItemFormPresenter`

export default defineMessages({
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  genericErrorMessage: {
    id: `${scope}.genericErrorMessage`,
    defaultMessage: 'Unable to create the statement item.',
  },
})
